import { DefaultOptionType } from 'antd/es/select';

export const sortOptionsAlphabetically = (optionA: DefaultOptionType, optionB: DefaultOptionType): number => {
  // Extract string labels from ReactNode
  const labelA = typeof optionA.label === 'string' ? optionA.label : '';
  const labelB = typeof optionB.label === 'string' ? optionB.label : '';

  return labelA.localeCompare(labelB);
};
